import type { AccessArea } from '@shared/types';
import { ButtonLink } from './Button';
import { EmptyState } from './EmptyState';
import { Lock } from './icons';

export const ACCESS_AREA_LABELS: Record<AccessArea, string> = {
  'task-management': 'Tasks',
  'pj-kpi-management': 'Projects & KPIs',
  'ricoh-spaces': 'Ricoh Spaces',
};

/** Page-level "you cannot see this" message, rendered inside the app shell. */
export function AccessDenied({ area, ownerOnly }: { area?: AccessArea; ownerOnly?: boolean }) {
  const what = ownerOnly ? 'This page is for owners only.' : area ? `You do not have access to ${ACCESS_AREA_LABELS[area]}.` : 'You do not have access to this page.';
  return (
    // data-access-denied lets scripts/ui-smoke.mjs detect a blocked page without text matching.
    <div data-access-denied="">
      <EmptyState
        icon={<Lock className="h-10 w-10" />}
        title="Access denied"
        description={`${what} Ask an owner to grant it on the Users page.`}
        action={
          <ButtonLink to="/" variant="secondary">
            Go to Home
          </ButtonLink>
        }
      />
    </div>
  );
}
